import styled from 'styled-components';

export const OfferInfoStyled = styled.section`
    background: var(--color-surface);
    border-radius: var(--radius-md);
    overflow: hidden;
`;

export const OfferInfoContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    padding: var(--space-5) var(--space-4);
`;

export const OfferInfoContentHeaderStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
    gap: var(--space-3) var(--space-4);

    h2 {
        margin: 0;
        font-size: var(--font-size-h4);
        font-weight: 600;
        color: var(--color-white-95);
    }
`;

export const OfferInfoContentTitleContainerStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2) var(--space-3);
    min-width: 0;
`;

export const OfferInfoTypeStyled = styled.div`
    display: inline-flex;
    align-items: center;
    font-weight: 600;
    font-size: var(--font-size-xs);
    line-height: 20px;
    padding: 0 var(--space-1);
    background: var(--background-neutral-20);
    border-radius: var(--radius-sm);
    color: var(--color-white-95);
`;

export const OfferInfoStatusStyled = styled.div`
    display: flex;
    align-items: center;
    gap: var(--space-2);
    color: var(--text-color-secondary);
    font-size: var(--font-size-xs);
    font-weight: 400;
    white-space: nowrap;

    .indicator {
        background: var(--text-color-secondary);
    }

    &.positive {
        color: var(--color-positive);

        .indicator {
            background: var(--color-positive);
        }
    }

    &.negative {
        color: var(--color-negative);

        .indicator {
            background: var(--color-negative);
        }
    }
`;

export const OfferInfoStatusIndicatorStyled = styled.div`
    width: 4px;
    height: 4px;
    border-radius: 2px;
`;

export const OfferInfoConditionsStyled = styled.div`
    padding: var(--space-3) var(--space-4);
    background: var(--color-surface-secondary);
    border-radius: var(--radius-md);

    table {
        width: 100%;
        border-collapse: collapse;
    }

    th {
        font-weight: 400;
        font-size: var(--font-size-md);
        color: var(--color-white-60);
        text-align: left;
        padding: var(--space-1) 0;
        vertical-align: top;
    }

    td {
        font-weight: 600;
        font-size: var(--font-size-md);
        color: var(--color-white-95);
        padding: var(--space-1) 0 var(--space-1) var(--space-6);
        text-align: right;
        white-space: nowrap;
    }
`;

export const OfferInfoReferralLinkStyled = styled.div`
    .offer-referral-link {
        width: 100%;
        padding: var(--space-2) var(--space-3);
        border-radius: var(--radius-md);
        background: var(--color-surface-secondary);
    }
`;

export const OfferInfoControlPanelStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2);
    padding: var(--space-4);
    background: var(--color-surface-secondary);
    border-top: 1px solid var(--color-main);
`;
